import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { LoadUserLoginCookiesAction, SaveFeedbackAction, StoreAction } from '../../../app/ActionsImpl';
import { useEffect } from 'react';
import { COOKIE_STORAGE, __DEV__ } from '../../../constants';



export interface Props extends StateProps, DispatchProps { }

function ResolveLogin(
    props: Props
) {

    const trustedOrigins = ['https://*.mojezmluvy.sk/', 'https://*.amplifyapp.com', 'http://localhost:3000', 'localhost:3000'];

    useEffect(() => {
        const messageHandler = (event: any) => {
            const isTrustedOrigin = trustedOrigins.some((origin) => {
                if (origin.includes('*')) {
                    // Create a regex pattern to match subdomains
                    const pattern = origin.replace(/\./g, '\\.').replace('*', '(.+)');
                    const regex = new RegExp(`^${pattern}$`);
                    return regex.test(event.origin);
                }
                return origin === event.origin;
            });
            if (isTrustedOrigin && event.data && event.data.action === "resolve-login") {
                const token = event.data.token;
                props.loadData(token)
            }

            if (isTrustedOrigin && event.data && event.data.action === "resolve-logout") {
                deleteCookies()
            }
        };

        window.addEventListener('message', messageHandler);

        // Clean up the event listener when the component is unmounted
        return () => {
            window.removeEventListener('message', messageHandler);
        };
    }, []);

    useEffect(() => {
        if (props.loginData) {
            deleteAndReplaceCookies(props.loginData)
        }
    }, [props.loginData])

    const deleteAndReplaceCookies = (newCookies: any, domain = __DEV__ ? window.document.location.hostname : COOKIE_STORAGE) => {
        const cookies = document.cookie.split('; ');
        console.log(window.document.location.hostname)
        // Delete all cookies with names starting with 'CognitoIdentityServiceProvider'
        for (const cookie of cookies) {
            const [name] = cookie.split('=');
            if (name.startsWith('CognitoIdentityServiceProvider')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; SameSite=None; path=/; Secure`;

            }
            console.log(name)
        }

        // Add new cookies from the object
        for (const [name, value] of Object.entries(newCookies)) {
            if (name.startsWith('CognitoIdentityServiceProvider')) {
                document.cookie = `${name}=${value}; domain=${domain}; SameSite=None; path=/; Secure`;
                console.log(name)
            }
        }
        window.parent.postMessage({ action: "LOGIN_FINISHED", origin: COOKIE_STORAGE}, '*'); 
    };

    const deleteCookies = (domain = __DEV__ ? window.document.location.hostname : COOKIE_STORAGE) => {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [name] = cookie.split('=');
            if (name.startsWith('CognitoIdentityServiceProvider')) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; domain=${domain}; SameSite=None; path=/; Secure`;

            }
        }
        window.parent.postMessage({ action: "LOGIN_FINISHED", origin: COOKIE_STORAGE}, '*'); 
    };

    return (
        <></>
    )
};

const mapStateToProps = ({ appState }: any) => ({
    user: appState.cognitoUser,
    loginData: appState.userLoginData
});

type StateProps = ReturnType<typeof mapStateToProps>;

export interface DispatchProps {
    loadData: (token: any) => void;
}

function mapDispatchToProps(dispatch: Dispatch<StoreAction, any>): DispatchProps {
    return {
        loadData: (token: any) => dispatch(LoadUserLoginCookiesAction(token))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResolveLogin);